// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************

const GET_ACTIVITY_LOG_SUCCESS = "GET_ACTIVITY_LOG_SUCCESS";
const GET_ACTIVITY_LOGS_SUCCESS = "GET_ACTIVITY_LOGS_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getLogSuccess(payload) {
  //  console.log(payload);
  return {
    type: GET_ACTIVITY_LOG_SUCCESS,
    payload: payload,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getLogsSuccess(payload) {
  //  console.log(payload);
  return {
    type: GET_ACTIVITY_LOGS_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************
/**
 *
 * @param {number} [id={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getLog(id = null, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Log@index")) {
      api
        .get(`/log/${id}`, { params })
        .then((res) => {
          dispatch(_getLogSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.activity-log",
              "activity-log"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getLogs(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Log@index")) {
      api
        .get("/log", { params })
        .then((res) => {
          dispatch(_getLogsSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.activity-log",
              "activity-log"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}
/**
 * حذف لاگ‌ها بر اساس بازه تاریخ
 * @param {Object} payload {from, to}
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function deleteLogs(payload = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Log@delete")) {
      api
        .delete("/log/DeleteLogs", { params: payload })
        .then((res) => {
                    dispatch(_getLogsSuccess(res));

          callback(undefined, res);
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.activity-log",
              "activity-log"
            )} - ${app.translate(
              "routes.home.basic.permission.delete",
              "delete"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    log: {},
    logs: [],
    meta: {},
  },
  action
) {
  switch (action.type) {

    
    case GET_ACTIVITY_LOG_SUCCESS:
      return Object.assign({}, state, {
        
        log: action.payload.data.logs,
        meta: action.payload.meta,
      });
    case GET_ACTIVITY_LOGS_SUCCESS:      

      return Object.assign({}, state, {
        logs: action.payload.data.logs,
        meta: action.payload.meta,
      });
    default:
      return state;
  }
}
